/**
 * Swaps an item with its neighbour. Returns the same array when the move would leave the list,
 * so callers can skip the save.
 */
export function moveItem<T>(items: readonly T[], index: number, direction: -1 | 1): T[] {
  const target = index + direction
  if (index < 0 || index >= items.length || target < 0 || target >= items.length) return items as T[]
  const next = [...items]
  ;[next[index], next[target]] = [next[target], next[index]]
  return next
}
